import { generateContext } from 'parkdepot-shared/utils/contextGenerator'
import { Lot } from '../../types/lot.interface'

export interface ILotContext {
    lot: Lot | null
    nextDisabled: boolean
    nextButtonLoading: boolean
    modifyAndSetLot: (lot: Lot) => void
    setLot: (lot: Lot) => void
    setNextDisabled: (disabled: boolean) => void
    setNextButtonLoading: (loading: boolean) => void
}

const [LotContext, LotContextProvider] = generateContext<ILotContext>()

export { LotContext }
export default LotContextProvider
